const updateScaleOptions = (modelSelect) => {
  const scaleSelect = modelSelect.closest('tr').querySelector('.js-growth-prediction-scale');
  const { scales, defaultScale } = modelSelect.selectedOptions[0].dataset;
  const options = JSON.parse(scales);
  const previousScale = scaleSelect.value;
  const selectedScale = options.some(([, value]) => value === previousScale)
    ? previousScale
    : defaultScale;

  scaleSelect.replaceChildren(...options.map(([label, value]) => (
    new Option(label, value, false, value === selectedScale)
  )));
};

export const initGrowthStagesPredictionSettings = () => {
  for (const modelSelect of document.querySelectorAll('.js-growth-prediction-model')) {
    modelSelect.addEventListener('change', () => updateScaleOptions(modelSelect));
  }
};
